import { Component } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import CommonGroupBuyScript from '@xt/client/mixins/order/groupbuy'
@Observer
@Component
export default class GroupBuyScript extends CommonGroupBuyScript {}
